module.exports = __webpack_public_path__ + "img/3.3cd13cb6.png";